import { render, staticRenderFns } from "./swiperIcons.vue?vue&type=template&id=466a21d3&scoped=true&"
import script from "./swiperIcons.vue?vue&type=script&lang=js&"
export * from "./swiperIcons.vue?vue&type=script&lang=js&"
import style0 from "./swiperIcons.vue?vue&type=style&index=0&id=466a21d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a21d3",
  null
  
)

export default component.exports